import { useCommon } from '../../../Hooks/Common/useCommon';
import { useGeneralSetting } from '../../../Hooks/Features/GeneralSetting/useGeneralSetting';

const GeneralSetting = () => {

    const { configurationData, handleInputChange, handleAddMore, upsertApplicationSetting,tagRef } = useGeneralSetting();
    const {checkPermission} = useCommon()


    return (
        <div ref={() => checkPermission("general", tagRef)}>
            <div ref={tagRef} id='{"tabname": "general_configuration", "data": "general_configuration_tab"}' className="mt-1" style={{ height: "calc(100vh - 100px)", overflowY: "auto", overflowX: "hidden" }}>
                <div className='d-flex justify-content-end mx-2'>
                    <button className='btn-primary' onClick={handleAddMore}>Add More</button>
                </div>
                <div style={{ height: "calc(100vh - 100px)", overflowY: "auto", overflowX: "hidden" }} >
                    {
                        configurationData?.map((value, index) => {
                            return <div className='row mx-2 my-1' key={index}>
                                <div className='col-md-3 col-5' >
                                    <input
                                        type="text"
                                        value={value?.configuration_name || ''}
                                        onChange={(e) => handleInputChange(index, 'configuration_name', e.target.value)}
                                        disabled={!value?.isNew}
                                        placeholder="Enter Name"
                                        className='input-dd w100 form-control'
                                        name='configuration_name'
                                    />
                                </div>
                                <div className='col-md-3 col-5' >
                                    <input
                                        type="text"
                                        value={value?.configuration_key || ''}
                                        onChange={(e) => handleInputChange(index, 'configuration_key', e.target.value)}
                                        disabled={!value?.isNew}
                                        placeholder="Enter Key"
                                        className='input-dd w100 form-control'
                                        name='configuration_key'
                                    />
                                </div>
                                <div className='col-md-4 col-5'>
                                    <input
                                        type="text"
                                        value={value?.configuration_value || ''}
                                        onChange={(e) => handleInputChange(index, 'configuration_value', e.target.value)}
                                        placeholder="Enter value"
                                        className='input-dd w100'
                                        name='configuration_value'
                                        onBlur={() => { if (!value?.isNew) upsertApplicationSetting(value, "configuration_value") }}
                                    />
                                </div>
                                <div className=' col-2 d-flex gap-2'>
                                    <input
                                        type="checkbox"
                                        checked={value?.is_active}
                                        onChange={(e) => {
                                            handleInputChange(index, 'is_active', e.target.checked, value?.isNew)
                                            !value?.isNew && upsertApplicationSetting(value, "is_active", e.target.checked)
                                        }}
                                        className='input-dd w100'
                                        name='is_active'
                                    />
                                    {
                                        value?.isNew && <div className='mt-1'>
                                            <button onClick={() => upsertApplicationSetting(value)}>Save </button>
                                        </div>
                                    }
                                </div>


                            </div>
                        })
                    }
                </div>
            </div>
        </div>
    );
};

export default GeneralSetting;
